export default __webpack_public_path__ + "static/media/rejtan.312b6634.png";